
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finds/search",
      function () {
        return require("private-next-pages/finds/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finds/search"])
      });
    }
  